import React from 'react';

import { FieldWidth } from './useFormField';

interface IProps {
  width: FieldWidth;
}

function FormFieldSpacer({ width }: IProps) {
  const widthFormatted = width.toString().replace('.', '-');

  return <div className={`novoFormField novoFormField--spacer novoFormField--width${widthFormatted}`} />;
}

export default FormFieldSpacer;
